<template>
  <div v-if="loaded">
     <ks-header title="购买会员卡"></ks-header>
     <div class="ka">
       <!-- 会员信息 -->
       <div class="ka-top" >
         <div class="ks-fl">您好，{{$store.state.userData.UserName}} ！<div class="ocl ks-fr">黄金会员</div></div>
         <div class="ks-fr">到期时间：<div class="ocl ks-fr">2019-10-19 09:22:27</div></div>
       </div>
       <!-- 会员卡轮播图 -->
       <div class="lbt">
         <van-swipe @change="onChange" :show-indicators="false" indicator-color="white">
          <van-swipe-item v-for="item in vipCardList" :key="item.cardid">
            <div class="lbt-item">
              <img :src="item.photourl" class="lbt-item__img">
              <!-- 已拥有的图片 -->
              <img v-if="item.has_result" class="lbt-item__alreadyowned" src="@/assets/user/alreadyowned.png">
              <div class="lbt-item__cardname">{{item.cardname}}</div>
            </div>
              <!-- 会员卡简介 -->
              <div class="membership">
                <div class="membership-title">会员简介：</div>
                <div v-if="item.has_result" class="membership-size">会员到期时间：{{item.has_result}}</div>
                <div class="membership-size">购买该会员后，享受全场购买优惠{{item.discount}}折！</div>
                <div class="membership-size">现价：{{item.price}}/个月&nbsp;&nbsp;&nbsp;原价：<s>{{item.linemoney}}/个月</s></div>
                <div class="membership-size">{{item.intro}}</div>
              </div>
          </van-swipe-item>
        </van-swipe>
       </div>
       <van-button round size="large" @click="open()">续费会员</van-button>
     </div>
  </div>
</template>

<script>
import {GetAllMyDiscountCard} from '@/apis/user'
export default{
  name:'MyDiscount',
  data(){
    return {
      index:0,
      loaded:false,
      vipCardList:[],
      alreadyowned:0
    }
  },
  methods:{
    open(){
      this.$router.push({
        name:'DiscountPayment',
        params:{
          id:this.vipCardList[this.index].cardid
        }
      })
    },
    onChange(index) {
       this.index = index
    }
  },
  created(){
    this.$toast.loading({
      mask: true,
      message: '加载中...'
    });
    GetAllMyDiscountCard({
      schoolid:SCHOOL_ID
    }).then(res=>{
      if(res.result){
        this.vipCardList = res.data
        console.log(this.vipCardList)
        console.log(res)
      }
      this.loaded = true
      this.$nextTick(()=>{
      this.$toast.clear()
      })
    })
    if(item.has_result == true){
        alreadyowned = true
      }else{
        alreadyowned = false
    }
  }
}
</script>


<style scoped>
  .ocl{
    color: #FF795C;
    font-weight:400;
    line-height: 11px;
  }
  .ka{
    background-color: #fff;
    padding-top: 11px;
    margin-top: 11px;
    height: 630px;
    position: relative;
  }
  .ka-top{
    line-height: 11px;
    color: #777777;
    font-size:11px;
    margin:0 30px 19px 30px;
  }
  .lbt{
    margin-top:0;
    width: 100%;
    height: 160;
  }
  .lbt-item{
    position: relative;
  }
  /* 已拥有的图片 */
  .lbt-item__alreadyowned{
    position:absolute;
    right: 33px;
    top: 19px;
  }
  .lbt-item__price{
     font-size: 12px;
     top: -60px;
     left: 60px;
  }
  .lbt-item__img{
    width: 100%;
    transform: scale(0.8) !important;
    border-radius: 10px;
  }
  .lbt-item__cardname{
    position:absolute;
    bottom: 40px;
    left: 60px;
    font-weight:600;
    font-size: 22px;
    color:rgba(0, 0, 0, .6)
  }
  .membership{
    padding: 0 20px;
    font-size:12px;
    line-height: 20px;
    color: #5f5f5f;
  }
  .membership-title{
    font-size: 16px;
    color: #3a3a3a;
  }
  .membership-size{
    margin-top: 7px;
    margin-left: 20px;
    font-size: 14px;
    color: #888888
  }
  .van-button{
    bottom: 20px;
    position: absolute;
    width: 85%;
    height: 44px;
    background-color: #FF795C;
    font-size: 15px;
    font-weight:600;
    color: #FFF;
    margin: 0 8%;
  }
</style>



// WEBPACK FOOTER //
// src/pages/user/MyDiscount.vue